var _path, _rect, _circle, _circle2, _circle3, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiResponseReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 43.5L17 41.5L15.5 30L17 18.5L33 17.5L49 18.5L50.5 21.5V39.5L48 43.5H35L23.5 48.5L24.5 43.5Z",
    fill: "#E3EDC3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27.1265,
    width: 20,
    height: 12.6437,
    rx: 5.45455,
    fill: "#274642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2051,
    cy: 33.3333,
    r: 2.29885,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5606,
    cy: 33.3333,
    r: 2.29885,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8848,
    cy: 22.2989,
    r: 2.29885,
    fill: "#274642"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9648,
    y: 23.6782,
    width: 1.83908,
    height: 3.44828,
    fill: "#274642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2414 34.0312H51.35C51.0392 34.0312 50.7411 34.1547 50.5214 34.3745C50.3016 34.5943 50.1781 34.8923 50.1781 35.2031C50.1781 35.5139 50.3016 35.812 50.5214 36.0318C50.7411 36.2515 51.0392 36.375 51.35 36.375H59.2414C67.257 36.375 67.4075 36.5283 67.4075 44.5781V52.1578C67.4075 60.2077 67.2547 60.3609 59.2414 60.3609C59.0373 60.3609 58.8367 60.4142 58.6595 60.5156C58.4824 60.6169 58.3347 60.7628 58.2312 60.9387C58.1278 61.1146 58.072 61.3146 58.0696 61.5187C58.0671 61.7228 58.118 61.924 58.2172 62.1023L59.7542 64.868C59.8619 65.0572 59.9525 65.2557 60.0252 65.4609C59.8222 65.3953 59.6252 65.3124 59.4364 65.213L50.2817 60.4922C50.1157 60.4067 49.9317 60.3621 49.745 60.3619H42.8727C34.8598 60.3619 34.707 60.2086 34.707 52.1587V44.0433C34.707 43.7325 34.5836 43.4344 34.3638 43.2146C34.144 42.9949 33.846 42.8714 33.5352 42.8714C33.2244 42.8714 32.9263 42.9949 32.7065 43.2146C32.4867 43.4344 32.3633 43.7325 32.3633 44.0433V52.1573C32.3633 61.5216 33.5422 62.7042 42.8727 62.7042H49.4605L58.362 67.2942C58.9783 67.6444 59.6694 67.8422 60.3777 67.8713C60.658 67.8808 60.9373 67.8325 61.1982 67.7293C61.459 67.626 61.6957 67.4701 61.8936 67.2713C62.3394 66.8119 62.9211 65.7403 61.8059 63.7284L61.2205 62.6808C68.743 62.4788 69.7517 60.8133 69.7517 52.1573V44.5781C69.7517 35.2134 68.5723 34.0312 59.2414 34.0312Z",
    fill: "#274642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1959 40.5659L42.1289 53.9669V55.0917L42.8054 56.1598H58.425L60.1289 55.5155V54.2969L59.5337 52.9925L52.4187 40.5659H50.1959Z",
    fill: "#E3EDC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6559 41.3952L42.3598 53.5755C42.0537 54.1056 42.0518 54.7584 42.355 55.2902C42.6581 55.822 43.2207 56.153 43.8328 56.1598H58.425C59.0371 56.153 59.5997 55.822 59.9028 55.2902C60.206 54.7584 60.2041 54.1056 59.898 53.5755L52.6019 41.3952C52.2896 40.8804 51.7311 40.5659 51.1289 40.5659C50.5267 40.5659 49.9682 40.8804 49.6559 41.3952Z",
    stroke: "#274642",
    strokeWidth: 1.55053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1299 45.823V49.2686",
    stroke: "#274642",
    strokeWidth: 1.72281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1295 52.7142H51.1381",
    stroke: "#274642",
    strokeWidth: 1.72281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2314 45.8259C21.1125 47.8312 21.6923 48.9037 22.1377 49.3645C22.3361 49.5649 22.574 49.7221 22.8361 49.826C23.0983 49.93 23.3792 49.9786 23.6611 49.9687C24.3691 49.9391 25.06 49.7416 25.6767 49.3926L34.6158 44.8031H41.2369C50.6006 44.8031 51.7837 43.6204 51.7837 34.2562V26.677C51.7837 17.3133 50.6006 16.1301 41.2369 16.1301H24.7969C15.4331 16.1301 14.25 17.3133 14.25 26.677V34.2572C14.25 42.915 15.2606 44.579 22.8141 44.7811L22.2314 45.8259ZM16.5938 34.2572V26.677C16.5938 18.6276 16.747 18.4739 24.7969 18.4739H41.2369C49.2863 18.4739 49.44 18.6276 49.44 26.677V34.2572C49.44 42.307 49.2863 42.4603 41.2369 42.4603H34.3331C34.1469 42.4604 33.9634 42.5049 33.7978 42.5901L24.6094 47.309C24.417 47.4105 24.2159 47.4944 24.0084 47.5598C24.0812 47.3549 24.1722 47.1569 24.2803 46.9683L25.823 44.2026C25.9225 44.0241 25.9735 43.8226 25.9711 43.6182C25.9687 43.4138 25.9128 43.2136 25.8091 43.0375C25.7054 42.8613 25.5574 42.7154 25.3798 42.6142C25.2022 42.5129 25.0013 42.4599 24.7969 42.4603C16.7475 42.4603 16.5938 42.307 16.5938 34.2572Z",
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiResponseReport);
export default __webpack_public_path__ + "static/media/ai-response-report.a7340a02447ea9c87186ed1132030252.svg";
export { ForwardRef as ReactComponent };